import PropTypes from 'prop-types';
import { attr, Model } from 'redux-orm';

class DashboardV2Appointment extends Model {
  static modelName = 'DashboardV2Appointment';

  static fields = {
    id: attr(),
    patientId: attr(),
    patient: attr(),
    workflowInstanceId: attr(),
    workflowDueAt: attr(),
    departmentAthenaId: attr(),
    providerAthenaId: attr(),
    date: attr(),
    time: attr(),
    departmentLocalDate: attr(),
    departmentLocalTime: attr(),
    departmentTimezone: attr(),
    visitType: attr(),
    clinician: attr(),
    location: attr(),
    noteUrl: attr(),
    readiness: attr(),
    tasks: attr(),
  };

  static schema = {
    _fields: PropTypes.exact({
      id: PropTypes.string,
      patientId: PropTypes.number,
      patient: PropTypes.object,
      workflowInstanceId: PropTypes.string,
      workflowDueAt: PropTypes.string,
      departmentAthenaId: PropTypes.string,
      providerAthenaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      date: PropTypes.string,
      time: PropTypes.string,
      departmentLocalDate: PropTypes.string,
      departmentLocalTime: PropTypes.string,
      departmentTimezone: PropTypes.string,
      visitType: PropTypes.string,
      clinician: PropTypes.string,
      location: PropTypes.string,
      noteUrl: PropTypes.string,
      readiness: PropTypes.object,
      tasks: PropTypes.array,
    }),
  };
}

export default DashboardV2Appointment;
